import AmountOfComplaints from "components/Cards/AmountOfComplaints";
import ComplaintOnOrganizationsList from "components/Cards/ComplaintOnOrganizationsList";
import ComplaintSubjectsGenderGap from "components/Cards/ComplaintSubjectsGenderGap";
import ComplaintsNumberByPopulationGroup from "components/Cards/ComplaintsNumberByPopulationGroup";
import DistributionOfComplaints from "components/Cards/DistributionOfComplaints";
import DistributionOfComplaintsByGender from "components/Cards/DistributionOfComplaintsByGender";
import DistributionOfComplaintsByResidence from "components/Cards/DistributionOfComplaintsByResidence";
import DistrictOfResidenceForComplainant from "components/Cards/DistrictOfResidenceForComplainant";
import HandlingComplaints from "components/Cards/HandlingComplaints";
import HowComplaintsAreReceived from "components/Cards/HowComplaintsAreReceived";
import LocalAuthoritiesThatHaveComplainedAbout from "components/Cards/LocalAuthoritiesThatHaveComplainedAbout";
import TopComplaintSubjects from "components/Cards/TopComplaintSubjects";
import Footer from "components/footer/footer";
import Const from "const.json";
import styles from '../../assets/styles/components/header.module.scss'
import React from "react";

const Body: React.FC = () => {

  return (
    <div className="container-main">
      <div className="d-flex flex-wrap">
          <div className={`${styles.header} d-block d-md-none w-100 align-items-center`} style={{'backgroundColor': 'unset', 'borderBottom': 'unset'}}>
            <h1 className='mb-0 d-block'>{Const.publicComplaintsSnapshot}</h1>
          </div>
        <section className="d-flex flex-wrap w-100 section z-3" id="overview" tabIndex={-1}>
          <h2 className="px-2 m-0 " >
            {Const.overview}
          </h2>
          <div className="col-md-6 col-12 p-2 parent-card">
            <AmountOfComplaints />
          </div>
          <div className="col-md-6 col-12 p-2 parent-card">
            <HandlingComplaints />
          </div>
        </section>
        <section
          className="d-flex flex-wrap w-100 section z-2"
          id="whoAreTheyComplainingAbout"
         tabIndex={-1}>
          <h2 className="px-2 m-0 pt-3" >
            {Const.whoAreTheyComplainingAbout}
          </h2>
          <div className="col-md-6 col-12 p-2 parent-card">
            <ComplaintOnOrganizationsList />
          </div>
          <div className="col-md-6 col-12 p-2 parent-card">
            <LocalAuthoritiesThatHaveComplainedAbout />
          </div>
        </section>
        <section
          className="d-flex flex-wrap w-100 section z-1"
          id="whatisTheComplaintAbout"
         tabIndex={-1}>
          <h2 className="px-2 m-0 pt-3" >
            {Const.whatisTheComplaintAbout}
          </h2>
          <div className="col-md-6 col-12 p-2 parent-card">
            <TopComplaintSubjects />
          </div>
          <div className="col-md-6 col-12 p-2 parent-card">
            <ComplaintSubjectsGenderGap />
          </div>
        </section>
        <section className="d-flex flex-wrap w-100 section z-0" id="howToSubmit" tabIndex={-1}>
          <h2 className="px-2 m-0 pt-3" >
            {Const.howToSubmit}
          </h2>
          <div className="col-12 p-2 parent-card">
            <HowComplaintsAreReceived />
          </div>
        </section>
        <section className="d-flex flex-wrap w-100 section" id="whoComplains" tabIndex={-1}>
          <h2 className="px-2 m-0 pt-3" >
            {Const.whoComplains}
          </h2>
          <div className="col-md-6 col-12 p-2 parent-card">
            <DistributionOfComplaintsByGender />
          </div>
          <div className="col-md-6 col-12 p-2 parent-card">
            <DistrictOfResidenceForComplainant />
          </div>
          <div className="col-md-6 col-12 p-2 parent-card">
            <ComplaintsNumberByPopulationGroup />
          </div>
          <div className="col-md-6 col-12 p-2 parent-card">
            <DistributionOfComplaintsByResidence />
          </div>
        </section>
        <section
          className="flex-wrap w-100 section d-lg-flex"
          id="tableOfDistributionByNilonLevels"
         tabIndex={-1}>
          <h2 className="px-2 m-0 pt-3" >
            {Const.tableOfDistributionByNilonLevels}
          </h2>
          <div className="col-12 p-2 parent-card">
            <DistributionOfComplaints />
          </div>
        </section>
      </div>
      <Footer />
    </div>
  );
};

export default Body;
